// extracted by mini-css-extract-plugin
export default {"fs":"c3cc9be9e0 _38964ff3d6"};